import { editMultipleField } from 'api/field'
import { FormControlLabel, TextField } from '@mui/material'
import { useSelector } from 'react-redux'
import { closeModal } from 'actions/app'
import ModalTool from 'components/modal/modal-tool'

export default function EditMultipleFields(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { fields, callback } = props

  const closePopup = useCallback(() => {
    dispatch(closeModal())
  })

  const selectedFarm = useSelector((state) => state.farm.singleton)
  const selectedClient = useSelector((state) => state?.client?.singleton)
  const farms = useSelector((state) => state.farm.collection || [])
  const clients = useSelector((state) => state?.client?.collection || [])
  const [farm, setFarm] = useState(
    selectedClient?.farms.length > 0
      ? selectedClient.farms[0].id
      : selectedFarm.id,
  )
  const [client, setClient] = useState(selectedClient.id)

  const [filteredFarms, setFilteredFarms] = useState(
    selectedClient?.farms || [],
  )
  const onSubmit = useCallback(() => {
    const data = []
    for (let i = 0; i < fields.length; i++) {
      data.push({ id: fields[i].id, name: fields[i].name, farmId: farm })
    }
    dispatch(editMultipleField(data, callback))
    dispatch(closeModal())
  }, [farm])

  const onChangeFarm = useCallback((e) => {
    setFarm(e.target.value)
  })

  const onChangeClient = useCallback(
    (e) => {
      const _client = parseInt(e.target.value)
      if (farm.clientId !== _client) {
        setFarm(null)
      }
      const _filteredFarms = farms.filter((f) => f.clientId == _client)
      setFilteredFarms(_filteredFarms)
      setClient(_client)
      if (_filteredFarms.length > 0) {
        setFarm(_filteredFarms[0].id)
      }
    },
    [farm, farms],
  )

  return (
    <ModalTool
      header={t('edit_fields')}
      content={
        <>
          {clients && clients.length > 1 ? (
            <FormControlLabel
              control={
                <TextField
                  sx={{ width: '25ch', padding: '10px' }}
                  select
                  name={'client'}
                  value={client}
                  onChange={onChangeClient}
                  slotProps={{ select: { native: true } }}
                  variant="outlined"
                  size="small"
                >
                  {clients.map((innerItem) => (
                    <option value={innerItem.id} key={innerItem.id}>
                      {innerItem.name}
                    </option>
                  ))}
                </TextField>
              }
              label={t('client')}
              labelPlacement="start"
            />
          ) : null}
          {filteredFarms && filteredFarms.length >= 1 ? (
            <FormControlLabel
              control={
                <TextField
                  sx={{ width: '25ch', padding: '10px' }}
                  select
                  name={'farm'}
                  value={farm}
                  onChange={onChangeFarm}
                  slotProps={{ select: { native: true } }}
                  variant="outlined"
                  size="small"
                >
                  {filteredFarms.map((innerItem) => (
                    <option value={innerItem.id} key={innerItem.id}>
                      {innerItem.name}
                    </option>
                  ))}
                </TextField>
              }
              label={t('farm')}
              labelPlacement="start"
            />
          ) : null}
        </>
      }
      onClose={closePopup}
      onApply={onSubmit}
      disabled={client === null || farm === null}
    />
  )
}
